import * as S from './styles'

export function Contacts({ contacts }: { contacts: any[] }) {
    return (
        <S.Container>
            {(contacts || []).map((contact: any, index: number) => (
                <S.Contact key={index}>
                    <S.ContactName>{contact.name}:</S.ContactName>
                    <S.ContactInformation>
                        {Object.keys(contact.phone || {}).length === 3 &&
                            <S.ContactData
                                href={`tel:+${contact?.phone?.international_dial_code}${contact?.phone?.area_code}${contact?.phone?.number}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                +{contact?.phone?.international_dial_code} ({contact?.phone?.area_code}) {contact?.phone?.number}
                            </S.ContactData>
                        }
                        {contact.email &&
                            <S.ContactData
                                href={`mailto:${contact.email}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {contact.email}
                            </S.ContactData>
                        }
                        {contact.url &&
                             <S.ContactData
                             href={contact.url}
                             target="_blank"
                             rel="noopener noreferrer"
                         >
                             {contact.url}
                         </S.ContactData>
                        }
                    </S.ContactInformation>
                </S.Contact>
            ))}
        </S.Container>
    )
}